import axios from 'axios';
import { getAccessToken } from './auth';

const baseURL = `${process.env.api_endpoint}/api/`

class Api {
  /**
   * @description make an axios request
   * @param {string} url
   * @param {string} method
   * @param {Object} requestData
   * @param {Object} customHeader
   */
  static buildRequest(url, method, requestData, customHeader) {
    const config = {
      baseURL,
      method,
      url,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAccessToken()}` },
      validateStatus(status) {
        return (status >= 200) && (status < 500)
      }
    }
    method = method.toUpperCase();
    if (method === 'POST' || method === 'PATCH' || method === 'PUT') {
      config.data = requestData
    }

    if (customHeader) {
      config.headers = Object.assign(config.headers, customHeader)
    }

    return Api.makeRequest(config)
  }

  static makeRequest(config) {
    return axios(config)
  }
}

export default Api



//////////////////
// WEBPACK FOOTER
// ./utils/api.js
// module id = /R+W
// module chunks = 1